// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.65);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    padding: 1rem;
}

.modal-content {
    background: var(--bg-card);
    border-radius: var(--radius);
    max-width: 420px;
    width: 100%;
    box-shadow: var(--shadow), 0 0 0 1px var(--border-subtle);
    border: 1px solid var(--border-color);
    overflow: hidden;
}

.modal-title {
    margin: 0;
    padding: 1.25rem 1.5rem 0;
    font-size: 1.25rem;
    color: var(--text-primary);
}

.modal-body {
    padding: 1rem 1.5rem;
    color: var(--text-secondary);
    line-height: 1.5;
}

.modal-body h4 {
    margin: 1rem 0 0.5rem;
    color: var(--text-primary);
    font-size: 1.1rem;
}

.modal-body ul {
    margin: 0.5rem 0;
    padding-left: 1.5rem;
}

.modal-body li {
    margin: 0.25rem 0;
}

.modal-footer {
    padding: 1rem 1.5rem 1.5rem;
    display: flex;
    justify-content: flex-end;
}

.modal-btn {
    padding: 0.5rem 1.5rem;
    border: none;
    border-radius: var(--radius-sm);
    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
    color: white;
    font-weight: 500;
    font-family: var(--font);
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
}

.modal-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px var(--accent-glow);
}

.modal-success .modal-title {
    color: var(--success);
}

.modal-error .modal-title {
    color: var(--error);
}

.modal-info .modal-title {
    color: var(--accent);
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;IACX,yDAAyD;IACzD,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,+BAA+B;IAC/B,+EAA+E;IAC/E,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":[".modal-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, 0.65);\r\n    backdrop-filter: blur(4px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 2000;\r\n    padding: 1rem;\r\n}\r\n\r\n.modal-content {\r\n    background: var(--bg-card);\r\n    border-radius: var(--radius);\r\n    max-width: 420px;\r\n    width: 100%;\r\n    box-shadow: var(--shadow), 0 0 0 1px var(--border-subtle);\r\n    border: 1px solid var(--border-color);\r\n    overflow: hidden;\r\n}\r\n\r\n.modal-title {\r\n    margin: 0;\r\n    padding: 1.25rem 1.5rem 0;\r\n    font-size: 1.25rem;\r\n    color: var(--text-primary);\r\n}\r\n\r\n.modal-body {\r\n    padding: 1rem 1.5rem;\r\n    color: var(--text-secondary);\r\n    line-height: 1.5;\r\n}\r\n\r\n.modal-body h4 {\r\n    margin: 1rem 0 0.5rem;\r\n    color: var(--text-primary);\r\n    font-size: 1.1rem;\r\n}\r\n\r\n.modal-body ul {\r\n    margin: 0.5rem 0;\r\n    padding-left: 1.5rem;\r\n}\r\n\r\n.modal-body li {\r\n    margin: 0.25rem 0;\r\n}\r\n\r\n.modal-footer {\r\n    padding: 1rem 1.5rem 1.5rem;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.modal-btn {\r\n    padding: 0.5rem 1.5rem;\r\n    border: none;\r\n    border-radius: var(--radius-sm);\r\n    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\r\n    color: white;\r\n    font-weight: 500;\r\n    font-family: var(--font);\r\n    cursor: pointer;\r\n    transition: transform 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.modal-btn:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 12px var(--accent-glow);\r\n}\r\n\r\n.modal-success .modal-title {\r\n    color: var(--success);\r\n}\r\n\r\n.modal-error .modal-title {\r\n    color: var(--error);\r\n}\r\n\r\n.modal-info .modal-title {\r\n    color: var(--accent);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
